import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
  showToast: boolean;

  constructor(private util: UtilitiesService) { }

  ngOnInit() {
    this.util.getToast().subscribe((state) => {
      this.showToast = state;
      setTimeout(() => {
        this.showToast = false;
      },2000);
    })
  }

}
